



















































































import { Component, Vue, Watch } from "vue-property-decorator"
import { STATUSES as SERVICE_REQUEST_STATUSES } from "@/constants/service_request"
import { mapState } from "vuex"
import _ from "lodash"
import ServiceRequestRead from "@/pages/Business/ServiceRequest/ServiceRequestRead.vue"

@Component({
  components: {
    ServiceRequestRead,
  },
  computed: {
    ...mapState("Auth", {
      business: "activeBusiness",
    }),
    ...mapState("Booking", {
      booking: "booking",
    }),
    ...mapState("ServiceItem", {
      serviceItems: "serviceItems",
    }),
  },
})
export default class BookingReadServiceCandidate extends Vue {
  booking!: Booking
  business!: Model
  serviceItems!: Model[]

  isMounted = false
  isLoading = false

  orderDetails: {
    service_item_oid: string | undefined;
    booking_candidate_oids: [];
  }[] = [{ service_item_oid: "", booking_candidate_oids: [] }]

  canSubmit = false

  // showServiceRequestRead = false

  serviceRequestStatues = SERVICE_REQUEST_STATUSES

  get bookingCandidates() {
    return this.booking.booking_candidates || []
  }

  get headers() {
    const headers = [
      {
        text: "Candidate",
        value: "candidate",
      },
    ]
    for (let i = 0; i < this.filteredServiceItems.length; i++) {
      headers.push({
        text: this.filteredServiceItems[i].name ?? "",
        value: "service_request",
      })
    }
    return headers
  }

  get filteredServiceItems() {
    return this.serviceItems.filter((item) => item.key != "assessment")
  }

  async mounted() {
    if (!this.serviceItems.length) {
      await this.$store.dispatch("ServiceItem/fetchList")
    }
    this.initOrderDetails()
    this.isMounted = true
  }

  initOrderDetails() {
    this.orderDetails = this.filteredServiceItems.map((serviceItem) => {
      return {
        service_item_oid: serviceItem.object_id,
        booking_candidate_oids: [],
      }
    })
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          "first_name",
          "last_name",
          "date_of_birth",
          "mobile",
          "email",
        ].includes(k) && item[k].toString().toLowerCase().includes(search)
      )
    })
  }

  name(item) {
    if (!item.first_name && !item.last_name) {
      return null
    }
    return (item.first_name ?? "") + " " + (item.last_name ?? "")
  }

  serviceRequest(serviceCandidates, serviceItemOid) {
    if (_.isEmpty(serviceCandidates)) {
      return null
    }

    const serviceCandidate = this.serviceCandidate(
      serviceCandidates,
      serviceItemOid
    )
    if (serviceCandidate && serviceCandidate.service_request) {
      return serviceCandidate.service_request
    } else {
      return null
    }
  }

  serviceCandidate(serviceCandidates, serviceItemOid) {
    if (_.isEmpty(serviceCandidates)) {
      return null
    }

    const serviceCandidate = serviceCandidates.find(
      (item) => item.service_item.object_id === serviceItemOid
    )
    return serviceCandidate
  }

  @Watch("orderDetails", { deep: true })
  watchOrderDetails(newVal) {
    let can = false
    if (newVal) {
      for (let i = 0; i < this.orderDetails.length; i++) {
        if (this.orderDetails[i].booking_candidate_oids.length > 0) {
          can = true
        }
      }
    }
    this.canSubmit = can
  }

  init() {
    // clear up current order details
    this.$store.dispatch("Booking/fetch", this.booking.object_id).then(() => {
      this.initOrderDetails()
      this.isLoading = false
    })
  }

  create() {
    this.isLoading = true
    const serviceRequest = {
      business_oid: this.business.object_id,
      order_details: this.orderDetails,
    }
    this.$store
      .dispatch("ServiceRequest/create", serviceRequest)
      .then(async () => {
        await this.init()
        this.$emit("clock")
      })
  }

  // async paid() {
  //   this.isInit = true
  //   await this.init()
  //   this.showServiceRequestRead = false
  // }
}
